<script setup lang="ts">
import type { AssociatedCompany } from '~/config'

interface Props {
  associatedCompanies: AssociatedCompany[]
}
defineProps<Props>()
</script>

<template>
  <div class="flex flex-col gap-2">
    <div>Respaldado por:</div>
    <GridComponent :cols="2">
      <template
        v-for="company in associatedCompanies"
        :key="company.code"
      >
        <ContentCompanyThumbnail :src="getCompanyLogo(company?.logoWhiteUrl)" />
      </template>
    </GridComponent>
  </div>
</template>
